export default __webpack_public_path__ + "static/naimatSCA-b1473ebf5069e51c0d485ac34602a114.webp";